import { Heading, HeadingProps } from '@hover/blueprint';
import React from 'react';

interface Props extends HeadingProps {
  content: string;
}

const Title: React.FC<Props> = ({ content, ...restProps }) => (
  <Heading
    marginBottom={0}
    isDisplay
    textAlign="center"
    size={{ base: 500, tablet: 600 }}
    {...restProps}
  >
    {content}
  </Heading>
);

export default Title;
